import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { APP_CONFIG, IAppConfig } from '../../app.config';
import { MessageService } from '../../core/service/message.service';
import { ProgressBarService } from '../../core/service/progress-bar.service';
import { DataService } from '../../core/service/base/data.service';
import { PriceList } from '../model/pricelist';
import { MeterMediaType } from '../model/const/enums';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ConsumptionDay } from '../model/consumption-day';
import { LocalDate } from '../../core/model/local-date';

@Injectable()
export class ConsumptionDayService extends DataService<ConsumptionDay> {
  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ConsumptionDay, progressBar, 'imd-meter-reading');
  }

  getPropertyValues(id: string, from: LocalDate, to: LocalDate, meterType: MeterMediaType): Observable<ConsumptionDay[]> {
    return this.client
      .get<any>(`${this.endpoint}/property/${id}/${meterType}/${from.toISOString()}/${to.toISOString()}`)
      .pipe(map(items => items.map(day => new ConsumptionDay(day))))
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }

  getMeterValues(id: string, from: LocalDate, to: LocalDate): Observable<ConsumptionDay[]> {
    return this.client
      .get<any>(`${this.endpoint}/object-meter/${id}/${from.toISOString()}/${to.toISOString()}`)
      .pipe(map(items => items.map(day => new ConsumptionDay(day))))
      .pipe(
        catchError(error => {
          console.log(error);
          return [];
        })
      );
  }
}
